/* Keep complete product names while aligning each visible row of cards. */
(() => {
  'use strict';
  if (!document.body.classList.contains('fr-design-system')) return;
  const slots = [
    ['swatches', '.fr-swatches'], ['title', 'h3'],
    ['meta', '.fr-card__meta, .fr-hosiery__variant'],
    ['rating', '.fr-card__rating'], ['price', '.fr-card__price, .fr-hosiery__price'],
    ['action', '.fr-card__form, .fr-hosiery__view']
  ];
  const shown = element => element && !element.hidden && element.getClientRects().length && getComputedStyle(element).display !== 'none';
  const outerHeight = element => {
    if (!shown(element)) return 0;
    const style = getComputedStyle(element);
    return element.getBoundingClientRect().height + (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
  };
  let frame = 0;
  const observed = new WeakSet();
  const widths = new WeakMap();
  const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(entries => {
    let changed = false;
    for (const entry of entries) {
      const width = entry.contentRect.width;
      if (Math.abs((widths.get(entry.target) ?? -1) - width) > .5) {
        widths.set(entry.target, width);
        changed = true;
      }
    }
    if (changed) schedule();
  }) : null;
  function align() {
    frame = 0;
    const groups = new Map();
    for (const card of document.querySelectorAll('.fr-card, .fr-hosiery__card')) {
      if (!shown(card)) continue;
      const body = card.querySelector(':scope > .fr-card__body') || (card.matches('.fr-hosiery__card') ? card : null);
      if (!body || !body.querySelector('h3')) continue;
      card.setAttribute('data-fr-card-aligned', '');
      const parent = card.parentElement;
      if (resize && !observed.has(parent)) {
        resize.observe(parent);
        observed.add(parent);
      }
      const top = card.getBoundingClientRect().top;
      let rows = groups.get(parent);
      if (!rows) groups.set(parent, rows = []);
      let row = rows.find(item => Math.abs(item.top - top) < 2);
      if (!row) rows.push(row = {top, cards: []});
      row.cards.push({body, heights: slots.map(([, selector]) => outerHeight(body.querySelector(':scope > :is(' + selector + ')')))});
    }
    for (const rows of groups.values()) for (const row of rows) {
      const heights = slots.map((_, index) => Math.ceil(Math.max(...row.cards.map(card => card.heights[index]))));
      for (const card of row.cards) slots.forEach(([name], index) => {
        const property = '--fr-card-row-' + name;
        const value = heights[index] + 'px';
        if (card.body.style.getPropertyValue(property) !== value) card.body.style.setProperty(property, value);
      });
    }
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(align);
  }
  new MutationObserver(schedule).observe(document.body, {
    subtree: true, childList: true, characterData: true,
    attributes: true, attributeFilter: ['class', 'hidden']
  });
  addEventListener('resize', schedule, {passive: true});
  addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('load', event => {
    if (event.target instanceof HTMLImageElement && event.target.closest('.fr-card, .fr-hosiery__card')) schedule();
  }, true);
  document.fonts?.ready.then(schedule);
  document.fonts?.addEventListener('loadingdone', schedule);
  schedule();
})();
